export default function getDocumentIcon(documentTypeId: ID) {
    const noteType = gd.session.noteTypes.get(documentTypeId)
    // default icon for cases when no note type found i.e. deleted and no missign data
    // const icon = noteType ? gd.const.note.icon[noteType.icon] : 'ii5-file-text'
    return noteType ? gd.const.note.icon[noteType.icon] : 'ii5-task-list'
}